import { TCloudflareTransformOptions } from "./image-helper";

const HERO_DESKTOP: TCloudflareTransformOptions = {
  w: 1600,
  fit: "scale-down",
};

const HERO_MOBILE: TCloudflareTransformOptions = {
  w: 375,
  dpr: 2,
  fit: "scale-down",
};

const HERO_MOBILE_SHAPE: TCloudflareTransformOptions = {
  w: 400,
  dpr: 2,
  fit: "scale-down",
};

const TEASER_BLOCK: TCloudflareTransformOptions = {
  w: 400,
  dpr: 2,
  fit: "scale-down",
};

const BANNER_BLOCK: TCloudflareTransformOptions = {
  w: 300,
  dpr: 2,
  fit: "scale-down",
};

const ARTICLE_HEADER_MOBILE: TCloudflareTransformOptions = {
  w: 400,
  dpr: 2,
  fit: "scale-down",
};

const ARTICLE_HEADER_DESKTOP: TCloudflareTransformOptions = {
  w: 1200,
  fit: "scale-down",
};

const cloudflareOptionPresets = {
  HERO_DESKTOP,
  HERO_MOBILE,
  HERO_MOBILE_SHAPE,
  TEASER_BLOCK,
  BANNER_BLOCK,
  ARTICLE_HEADER_MOBILE,
  ARTICLE_HEADER_DESKTOP,
};

export { cloudflareOptionPresets };
